import FormHeaderV1 from "../../../../components/form_builder/elements/form_header/FormHeaderV1.vue";

export default {
  componentName: "fb-form-header-v1",
  component: FormHeaderV1,
  defaultAttrs: {
    properties: {
      value: `
        <div class="row">
          <div class="col col-3 my-auto">
            <img height="75" src="{{systemSetting.logo}}"/>
          </div>
          <div class="col col-6 text-center my-auto"><h4 class="mb-0">{{form.name}}</h4><small class="font-italic">{{document.effectiveDate ? ('Date:' + formatDate(document.effectiveDate )) : ''}}</small></div>
          <div class="col col-3 my-auto text-right">
          <small><strong>{{formatEoc(client.firstName, client.lastName, client.mrn, client.episodeOfCare.eocn)}}<br/>
            DOB: {{formatDateOnly(client.dateOfBirth)}}<br/>
            Start Date: {{formatDate(client.episodeOfCare.startDate )}}</strong></small>
          </div>
        </div>
      `,
      style: {}
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
